import axios, { AxiosError } from 'axios';
import ApplicationConfig from '../config';
import { Dispatch, UnknownAction } from '@reduxjs/toolkit';
import { updateQuickNotificationDetails } from '../features/notifications/notificationsSlice';

const api = axios.create({
  baseURL: ApplicationConfig.apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true
})

let refreshAttempts = 0;
const MAX_REFRESH_ATTEMPTS = 5;

// async function refreshToken() {
//   try {
//     await axios.post(`${ApplicationConfig.apiBaseUrl}/auth/token/refresh`, {}, { withCredentials: true });
//     return true; // Token refreshed successfully
//   } catch (error) {
//     console.error('Failed to refresh token:', error);
//     return false; // Handle logout or re-authentication
//   }
// }

async function refreshToken() {
  if (refreshAttempts >= MAX_REFRESH_ATTEMPTS) {
    console.error('Maximum token refresh attempts reached');
    return false; // Prevent further attempts
  }

  try {
    refreshAttempts++;
    await axios.post(`${ApplicationConfig.apiBaseUrl}/auth/token/refresh`, {}, { withCredentials: true });
    return true; // Token refreshed successfully
  } catch (error) {
    console.error('Failed to refresh token:', error);
    return false; // Handle logout or re-authentication
  }
}

// Response interceptor to handle token expiration
api.interceptors.response.use(response => response, async (error) => {
  const originalRequest = error.config;

  // Check if error is due to token expiration and retry once
  if (error.response && error.response.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true; // Mark request as retried

    const refreshed = await refreshToken();
    if (refreshed) {
      return api(originalRequest); // Retry the original request
    }
  }

  return Promise.reject(error); // Forward other errors
});

// export const handleRequestError = (error: { [key: string] : any }, dispatch: Dispatch<UnknownAction>) => {
//       let message: string = "Unknown Error"

//       try{
//         const { status, data } = error.response
        
//         if (data.message){
//           message = data.message
//         }
//       }catch (error){
//           console.log("error handleRequestError(): ", error)
//       }

//       updateQuickNotificationDetails(true, message, "error", dispatch)
// }

export const handleRequestError = (
  error: { [key: string]: any },
  dispatch: Dispatch<UnknownAction>
) => {
  let message: string = "Unknown Error";

  try {
    if (error.response) {
      const { status, data } = error.response;

      if (data?.message) {
        message = data.message;
      } else {
        message = `Request failed with status ${status}`;
      }
    } else if (error.request) {
      // The request was made but no response was received
      message = "No response from server. Please check your connection.";
    } else if (error.message) {
      // Something else happened in setting up the request
      message = error.message;
    }
  } catch (err) {
    console.error("error handleRequestError(): ", err);
  }

  updateQuickNotificationDetails(true, message, "error", dispatch);
}

export default api